import * as React from 'react';
import * as UserActions from '../../actions/users';
import { RouteComponentProps } from 'react-router';
import { UserData } from '../../models/User';
import * as request from 'superagent';
import { toast } from 'react-toastify';

export namespace Register {
	export interface Props extends RouteComponentProps<void> {
		userActions: typeof UserActions;
		toggleRegistration: (e: any)=>void;
	}

	export interface State {
		schools: string[];
	}
}

export default class Register extends React.Component<Register.Props, Register.State> {

	username: HTMLInputElement;
	password: HTMLInputElement;
	password2: HTMLInputElement;
	firstname: HTMLInputElement;
	lastname: HTMLInputElement;
	school: HTMLSelectElement;
	code: HTMLInputElement;

	constructor(props: Register.Props) {
		super(props);
		this.registerUser = this.registerUser.bind(this);

		this.state = { schools: [] };

		request
			.get('/user/schools')
			.end((err, res) => {
				if (err) {
					console.log(res.text);
				} else {
					this.setState({schools: res.body})
				}
			});
	}

	registerUser(e: any) {
		e.preventDefault();

		if (this.password.value !== this.password2.value) {
			toast.error('Salasanat eivät täsmää');
			return;
		}

		const { userActions } = this.props;
		const userData: UserData = {
			_id: null,
			firstname: this.firstname.value,
			lastname: this.lastname.value,
			username: this.username.value,
			password: this.password.value,
			school: this.school.value
		};
		userActions.registerUser({user: userData, code: this.code.value});
	}

	render() {
		const { schools } = this.state;

		let schoolDOMs = [];
		for (let i = 0; i < schools.length; i++) {
			schoolDOMs.push(<option value={schools[i]}>{schools[i]}</option>);
		}

		return (
			<div>
				<form className="form-group" id="am_login" onSubmit={this.registerUser}>
					<input ref={(input) => this.username = input} className="col-12 form-control" placeholder="Käyttäjätunnus" required/>
					<input ref={(input) => this.password = input} className="col-12 form-control" placeholder="Salasana" type="password" required/>
					<input ref={(input) => this.password2 = input} className="col-12 form-control" placeholder="Salasana uudelleen" type="password" required/>
					<input ref={(input) => this.firstname = input} className="col-12 form-control" placeholder="Etunimi" required/>
					<input ref={(input) => this.lastname = input} className="col-12 form-control" placeholder="Sukunimi" required/>
					<input ref={(input) => this.code = input} className="col-12 form-control" placeholder="Koodi" required/>
					<select ref={(input) => this.school = input} className="col-12 form-control mb-3">
							{schoolDOMs}
					</select>
					<button type="submit" className="col-12 btn form-control am_green-button am_shadow">REKISTERÖI</button>
					<button onClick={this.props.toggleRegistration} className="col-12 form-control am_darkblue-button am_shadow mt-3">KIRJAUDU</button>
				</form>			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/LoginTeacher/register.tsx